import { DocumentType } from "@nemuru-eng/js-api-client";
import { DocumentAddressMapper } from "./DocumentAddressMapper";
import { FamiliarSituationDetailsMapper } from "./FamiliarSituationDetailsMapper";
import { MainResidenceDetailsMapper } from "./MainResidenceDetailsMapper";
import { FormatDateMapper } from "../FormatDateMapper";

const IdVerificationFormDataMapper = {
  reverseMap(data) {
    return {
      document_type: data.documentType,
      first_name: data.firstName,
      last_name: data.lastName,
      date_of_birth: FormatDateMapper.dehydrate(data.dateOfBirth),
      personal_identification_number: data.personalIdentificationNumber,
      nationality: data.nationality,
      gender: data.gender,
      issuing_country: data.issuingCountry,
      date_of_expiry: data.dateOfExpiry
        ? FormatDateMapper.dehydrate(data.dateOfExpiry)
        : null,
      place_of_birth: data.placeOfBirth || null,
    };
  },
};

export const UserDetailsWithIdDocumentVerificationFormDataMapper = {
  reverseMap(data, participant) {
    const merged = {
      ...data,
      address: { ...data.address, ...data.complementAddress },
    };
    return {
      op: "processPatchSetUserDetailsWithIdDocumentVerificationFormData",
      id: participant.participantId,
      loan_id: data.loan.id,
      type: data.loan.asset_reference[0].type,
      id_document_verification_form_data:
        IdVerificationFormDataMapper.reverseMap(merged),
      document_address: DocumentAddressMapper.reverseMap(merged),
      familiar_situation_details:
        FamiliarSituationDetailsMapper.reverseMap(merged),
      main_residence_details: MainResidenceDetailsMapper.reverseMap(merged),
      ...(data.documentType === DocumentType.NIE_EU && {
        complement_nie_eu: {
          nationality: merged.nationality,
          gender: merged.gender,
          passport_image: merged.passportFront?.result,
        },
      }),
    };
  },
};
